import { FunctionComponent } from 'preact';
import { Stack } from 'components/Stack';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../models/Card.model';
import { DoubleCards } from '../../Cards/DoubleCards';
import { MobileCard } from '../../Cards/MobileCard';
import { SingleCard } from '../../Cards/SingleCard';
import { HorizontalSlider } from '../HorizontalSlider';
import { TripleQuadrupledCards } from '../../Cards/TripleQuadrupledCards';
import { usePTPConfigContext } from '../../../../../../../GlobalConfig.context';

interface SliderProps {
  cards: Card[];
}

const Slider: FunctionComponent<SliderProps> = ({ cards }) => {
  const { t } = useTranslation();
  const { isMobile } = useDetectDevice();
  const PTPConfig = usePTPConfigContext();
  const lineItemConfig = PTPConfig?.lineItem;
  const { productDescription: productDescriptionConfig } = lineItemConfig;
  const showDetailButton =
    productDescriptionConfig.isShow || productDescriptionConfig.showUrl;
  if (isMobile) {
    return (
      <Stack direction="column" gap={16} align="center">
        {cards.map((card) => (
          <MobileCard showDetailButton={showDetailButton} card={card.data} />
        ))}
      </Stack>
    );
  }

  if (cards.length === 1) {
    return <SingleCard card={cards[0]} />;
  }

  if (cards.length === 2) {
    return <DoubleCards shouldFlip={showDetailButton} cards={cards} />;
  }

  if (cards.length === 3 || cards.length === 4) {
    return (
      <TripleQuadrupledCards shouldFlip={showDetailButton} cards={cards} />
    );
  }

  return (
    <HorizontalSlider
      shouldFlip={showDetailButton}
      cards={cards}
      spaceBetween={16}
      ariaLabel={t('ALT_TEXT_LINE_ITEMS_SLIDER')}
    />
  );
};

export { Slider };
